<template>
  <div>
    <div class="flex flex-col w-full mb-4">
      <label class="font-semibold text-sm text-grey-700 mb-2">
        {{ $t('frontend_groovemember_files_name') }}
      </label>
      <text-input
        v-model="upload_file.name"
        :validator="$v.upload_file.name"
        :attribute="'Name'"
        :placeholder="$t('frontend_groovemember_files_name')"
      />
    </div>
    <div class="flex flex-col w-full mb-4">
      <label class="font-semibold text-sm text-grey-700 mb-2"> Category </label>
      <treeselect
        v-model="upload_file.category_id"
        class="h-10"
        :multiple="false"
        :options="categories"
        :closeOnSelect="true"
        :clearable="false"
        :clearOnSelect="true"
        :isDefaultExpanded="true"
        :defaultExpandLevel="1"
        :showCount="true"
        :max-height="200"
        :normalizer="normalizer"
        @input="() => {}"
        :placeholder="'Select Category'"
      />
    </div>
    <vue-dropzone
      id="customdropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      :use-custom-slot="true"
      :awss3="awss3"
      @vdropzone-mounted="uploaderMounted"
      @vdropzone-success="uploadSuccess"
      @vdropzone-s3-upload-error="uploadError"
      @vdropzone-upload-progress="uploadProgress"
      @vdropzone-total-upload-progress="totalProgress"
      @vdropzone-file-added="fileAdded"
    >
      <div class="dropzone-custom-content">
        <div
          class="
            rounded-lg
            bgcolor
            flex flex-col
            h-40
            justify-center
            items-center
            px-4
          "
        >
          <div
            class="
              w-full
              flex flex-row flex-nowrap
              items-center
              justify-center
              text-sm
              subtitle
              mb-1
            "
          >
            {{ $t('frontend_groovemember_files_drag_and_drop') }}
          </div>
          <div
            class="
              w-full
              flex flex-row flex-nowrap
              items-center
              justify-center
              text-sm
              subtitle
              mb-3
            "
          >
            - {{ $t('frontend_groovemember_files_or') }} -
          </div>
          <div
            class="w-full flex flex-row flex-nowrap items-center justify-center"
          >
            <gd-button primary class="px-4 w-auto mr-2">
              {{ $t('frontend_groovemember_select_file') }}
            </gd-button>
          </div>
          <div
            class="
              text-sm
              subtitle
              mt-3
              w-full
              flex flex-row flex-nowrap
              items-center
              justify-center
            "
          >
            {{ $t('frontend_groovemember_files_max_size') }}
          </div>
        </div>
      </div>
    </vue-dropzone>
    <gd-button
      :disabled="!isUploadFormValid || uploadBtnDisabled"
      class="text-center w-40 mt-5"
      size="large"
      primary
      @click="uploadFilesToServer"
    >
      {{ $t('frontend_groovemember_files_upload_file') }}
    </gd-button>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
export default {
  name: 'FileUpload',
  props: {
    allowedFiles: { default: () => null },
  },
  data() {
    return {
      uploadBtnDisabled: false,
      categories: [],
      uploadProgressStatus: 0,
      currentUploadedFile: null,
      dropzoneOptions: {
        url: `${window.config.apiCoreUrl}/groovemember/upload`,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: 200,
        autoProcessQueue: false,
        autoQueue: true,
        success_action_status: 201,
        acceptedFiles: this.allowedFiles,
      },
      awss3: {
        signingURL: `${window.config.apiCoreUrl}/groovemember/get-pre-sign-url`,
        headers: {
          email: null,
          apiKey: null,
        },
        params: {},
        sendFileToServer: false,
        withCredentials: false,
      },
      upload_file: {
        name: '',
        category_id: null,
        file: null,
      },
    };
  },
  validations: {
    upload_file: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(160),
      },
      category_id: {
        required,
      },
    },
  },
  components: {
    Treeselect,
    vueDropzone: vue2Dropzone,
  },
  computed: {
    isUploadFormValid() {
      if (
        this.upload_file.file &&
        this.upload_file.category_id &&
        this.upload_file.name.length >= 3 &&
        this.upload_file.name.length <= 160
      ) {
        return true;
      }
      return false;
    },
  },
  async mounted() {
    try {
      this.categories = await this.loadCategories();
      this.upload_file.category_id = 1;
    } catch (err) {
      /** */
    }
  },
  methods: {
    uploaderMounted() {},
    normalizer(node) {
      return {
        id: node.id,
        label: node.category,
        children: node.child && node.child.length ? node.child : undefined,
        user_id: node.user_id,
      };
    },
    async uploadSuccess(file, response) {
      if (response && response.Key) {
        const test = await this.fileUploaded({
          name: this.upload_file.name,
          category_id: this.upload_file.category_id,
          originalName: this.upload_file.file.name,
          cloudName: response.Key,
          size: this.upload_file.file.size,
          mimeType: this.upload_file.file.type,
        }).then((d) => d.data);
        this.uploadBtnDisabled = false;
        this.$emit('selected', test);
      }
    },
    fileUploaded(response) {
      return api.post(
        `${window.config.apiCoreUrl}/groovemember/membership/file`,
        {
          ...response,
        }
      );
    },
    uploadError(response) {
      console.log({ response });
    },
    uploadProgress(file, progress, bytesSent) {
      this.uploadProgressStatus = progress;
      this.uploadProgressStatus = Math.round(this.uploadProgressStatus);
    },
    totalProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      console.log(totaluploadprogress, totalBytes, totalBytesSent);
    },
    fileAdded(addedFile) {
      if (this.currentUploadedFile) {
        this.$refs.myVueDropzone.removeFile(this.currentUploadedFile);
      }
      this.currentUploadedFile = addedFile;
      this.upload_file.file = addedFile;
    },
    async uploadFilesToServer() {
      if (this.upload_file) {
        this.uploadBtnDisabled = true;
        const self = this;

        setTimeout(async () => {
          // Check queued file
          if (self.$refs.myVueDropzone.getQueuedFiles().length) {
            const element = self.$el.querySelector('#customdropzone');
            // Initiate file upload
            self.$refs.myVueDropzone.processQueue();
          }
        }, 300);
      }
    },
    async loadCategories() {
      try {
        const categoryData = await api
          .get(
            `${window.config.apiCoreUrl}/groovemember/file-category?childGrouping=true`
          )
          .then((d) => d.data);

        return categoryData;
      } catch (err) {
        console.log(err);
        return [];
      }
    },
  },
};
</script>